export interface ValueAndKey {
  value?: string | null;
  key?: string | null;
}

export interface Option {
  label: string;
  value: string;
}

type NonNullableFields<T> = {
  [P in keyof T]: NonNullable<T[P]>;
};

const isRequiredValueAndKey = (
  item: ValueAndKey
): item is Required<NonNullableFields<ValueAndKey>> =>
  !!item?.value && !!item?.key;

export const getOptions = (data: ValueAndKey[] | null | undefined): Option[] =>
  (data || [])
    .filter(isRequiredValueAndKey)
    .map((item) => ({ label: item.value, value: item.key }))
    .sort((a, b) => a.label.localeCompare(b.label));
